package com.evoapps.evoshift.data.repository

import com.evoapps.evoshift.data.remote.AppFirestore
import com.evoapps.evoshift.domain.repository.ReferralRepository
import kotlinx.serialization.Serializable

/** The one field of `users/{uid}` this repository reads (SH-239). */
@Serializable
internal data class ReferralFieldDto(val referralCode: String? = null)

/**
 * SH-239: the person's referral code on their profile, `users/{uid}.referralCode`. firestore.rules
 * let the person set it once (8 characters of the join codes' alphabet) and never change it, so a
 * second device writing its own code at the same moment is refused: the code already kept wins.
 */
class ReferralRepositoryImpl(private val firestore: AppFirestore) : ReferralRepository {
    override suspend fun get(uid: String): Result<String?> = runCatching { read(uid) }

    override suspend fun createIfMissing(uid: String, code: String): Result<String> = runCatching {
        read(uid)?.let { return@runCatching it }
        try {
            firestore.collection("users").document(uid).updateFields { "referralCode" to code }
            code
        } catch (e: Exception) {
            read(uid) ?: throw e
        }
    }

    private suspend fun read(uid: String): String? {
        val snapshot = firestore.collection("users").document(uid).get()
        if (!snapshot.exists) return null
        return snapshot.data<ReferralFieldDto>().referralCode?.takeIf { it.isNotBlank() }
    }
}
